import { Instance } from 'mobx-state-tree';
import { VisitsGeocodedDtoModelBase } from './VisitsGeocodedDtoModel.base';

/* The TypeScript type of an instance of VisitsGeocodedDtoModel */
export interface VisitsGeocodedDtoModelType extends Instance<typeof VisitsGeocodedDtoModel.Type> {}

/* A graphql query fragment builders for VisitsGeocodedDtoModel */
export { selectFromVisitsGeocodedDto, visitsGeocodedDtoModelPrimitives, VisitsGeocodedDtoModelSelector } from './VisitsGeocodedDtoModel.base';

/**
 * VisitsGeocodedDtoModel
 */
export const VisitsGeocodedDtoModel = VisitsGeocodedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
